import { Ingrediente } from "../types/ingrediente.type";
import { TipoIngrediente } from "../types/tipoIngrediente.type";
import ApiService from "./apiService";

const endpoint = "/api/v1/negocios/tipos-ingredientes";

type CreateTipoIngredientePropio = {
  nombre: string;
  titulo: string;
  minimo: number;
  maximo: number;
  repetible: boolean;
};

type CreateTipoIngredienteGlobal = CreateTipoIngredientePropio & {
  ingredientes: Pick<Ingrediente, "nombre" | "precio" | "disponible">[];
};

type UpdateTipoIngrediente = CreateTipoIngredientePropio &
  Partial<Pick<CreateTipoIngredienteGlobal, "ingredientes">> & {
    ingredientesActualizados?: boolean;
    global: boolean;
  };

class TiposIngredientesService extends ApiService {
  getAll() {
    return this.get<TipoIngrediente[]>(`${endpoint}`, {
      negocioActivo: true,
    });
  }

  getPropios() {
    return this.get<Omit<TipoIngrediente, "ingredientes">[]>(`${endpoint}/propios`, {
      negocioActivo: true,
    });
  }

  getGlobales() {
    return this.get<TipoIngrediente[]>(`${endpoint}/globales`, {
      negocioActivo: true,
    });
  }

  createPropio(createTipoIngrediente: CreateTipoIngredientePropio) {
    return this.post<TipoIngrediente>(`${endpoint}/propios`, createTipoIngrediente, {
      negocioActivo: true,
    });
  }

  createGlobal(createIngrediente: CreateTipoIngredienteGlobal) {
    return this.post<TipoIngrediente>(`${endpoint}/globales`, createIngrediente, {
      negocioActivo: true,
    });
  }

  update(updateIngrediente: UpdateTipoIngrediente, id: number) {
    return this.put<TipoIngrediente>(`${endpoint}/${id}`, updateIngrediente, {
      negocioActivo: true,
    });
  }

  delete(tipoIngredienteId: number) {
    return this.del(`${endpoint}/${tipoIngredienteId}`, {
      negocioActivo: true,
    });
  }
}

const tiposIngredientesService = new TiposIngredientesService();
export default tiposIngredientesService;
